export const postStatusTime = 1000

export const getJobTitleChineseName = (jobTitle) => {
    const titleMap = {
      DOCTOR: "醫師",
      COUNSELLOR: "諮詢師",
      NURSE: "護理師",
      AESTHETICIAN: "美容師",
    };
    return titleMap[jobTitle] || "員工";
};

export const calendarStatusColor = {
  "00": "#66A2FC",
  "01": "#66A2FC",
  "02": "#66A2FC",
  10: "#FF577F",
  11: "#FF577F",
  12: "#808080",
  20: "#D9D9D9",
  21: "#F39D5F",
  22: "#D9D9D9",
  23: "#D9D9D9",
  24: "#D9D9D9",
  25: "#D9D9D9",
  30: "#FC8A66",
  31: "#FC8A66",
};

export const checkoutStatusColor = {
  10: "#000",
  11: "#000",
  12: "#000",
  14: "#000", // only in appointment?
  21: "#91AECE",
  22: "#91AECE",
  23: "#91AECE",
  24: "#91AECE",
};

export const memberSideBarMenu = [
  "預約列表",
  "結帳紀錄",
  "顧客管理",
  "課程管理",
  "顧客相簿",
  "諮詢紀錄",
  // 術前同意書、問卷單已整併進「簽署中心」（含付款同意書、療程後確認單、轉贈同意書）
  "簽署中心",
  "病歷管理",
  "檔案管理",
];

export const memberListMenu = {
  預約列表: ["即將到來", "歷史預約", "已取消"],
  結帳紀錄: [],
  顧客管理: [],
  課程管理: ["目前課程", "歷史紀錄"],
  顧客相簿: [],
  諮詢紀錄: [],
  術前同意書: [],
  問卷單: [],
  病歷管理: [],
  檔案管理: [],
};

//deprecated
export const customerSideBarMenu = [
  "預約列表",
  "結帳紀錄",
  "顧客管理",
  "課程管理",
  "顧客相簿",
];

//deprecated
export const scanListMenu = {
  預約列表: ["即將到來", "歷史預約", "已取消"],
  結帳紀錄: [],
  顧客管理: [],
  票券管理: [],
};


//deprecated
export const scanSideBarMenu = [
  "預約列表", 
  "結帳紀錄", 
  "顧客管理", 
  "票券管理"
];
